import { render, staticRenderFns } from "./PhoneAuth.vue?vue&type=template&id=f7a828fc&scoped=true&"
import script from "./PhoneAuth.vue?vue&type=script&lang=ts&"
export * from "./PhoneAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a828fc",
  null
  
)

export default component.exports